import { DependencyList, useCallback, useEffect, useRef } from 'react';

export default function useResize(onResize: () => void, deps: DependencyList = []) {
    const initialResizeRef = useRef(true);

    const handleResize = useCallback(onResize, deps);

    const dispatchResize = () => {
        window.dispatchEvent(new Event('resize'));

        process.nextTick(() => window.dispatchEvent(new Event('resize')));
    };

    useEffect(() => {
        window.addEventListener('orientationchange', handleResize);
        window.addEventListener('resize', handleResize);

        if (initialResizeRef.current) {
            initialResizeRef.current = false;

            dispatchResize();
        }

        return () => {
            window.removeEventListener('orientationchange', handleResize);
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);

    return dispatchResize;
}
